import React from 'react';
import BlogContent from '../../blogs/blogDetails/BlogContent';
import * as blogStyles from '../../blogs/blogDetails/BlogPost.module.css';
import { authorName } from './articleHelpers';

const AuthorIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="#5B6472" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;

const ArticleBody = ({ post }) => (
    <section className="lp-article-body-sec">
        <div className="lp-article-body-inner">
            {post.excerpt && <p className="lead">{post.excerpt}</p>}

            <div className="article-body">
                {Object.values(post.postData || {}).map((sec, i) => (
                    <BlogContent key={i} sec={sec} styles={blogStyles} />
                ))}
            </div>

            <div className="lp-article-author-card">
                <span className="avatar"><AuthorIcon /></span>
                <div>
                    <div className="name">{authorName(post)}</div>
                    <div className="role">{post.author?.role}</div>
                </div>
            </div>
        </div>
    </section>
);

export default ArticleBody;
